import { MOCK_SEED_IDS } from '@/constants/mockSeedIds'

const FRONTFLOW_TENANT_ID =
  import.meta.env.VITE_FRONTFLOW_ORG_TENANT_ID ?? MOCK_SEED_IDS.organization.tenantId

export function isFrontFlowOrg(tenantId?: string) {
  return !!tenantId && tenantId === FRONTFLOW_TENANT_ID
}
